import { render, staticRenderFns } from "./GruposPage.vue?vue&type=template&id=c198a622"
import script from "./GruposPage.vue?vue&type=script&lang=js"
export * from "./GruposPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports